// Auto-generated by scripts/inject-version.ts — do not edit.
export const SDK_VERSION = '0.3.5';
//# sourceMappingURL=version.js.map